import React, { FC } from 'react';
import { Button, Divider, Grid, Space } from 'antd';
import { ContentBlock } from '../../../../uicomp/atmos/content-block/ContentBlock';
import { ArrowLeftOutlined } from '@ant-design/icons';

type Props = {
  title: string;
  onApply?: () => void;
  onCancel?: () => void;
  id?: string;
};

export const FilterTitle: FC<Props> = (props) => {
  const bp = Grid.useBreakpoint();
  if (bp.md) {
    return <div />;
  }
  return (
    <Space direction={'vertical'} className={'fullwidth'}>
      <ContentBlock
        heading
        align={'center'}
        left={
          <Button onClick={props.onCancel} size={'small'} type={'link'}>
            <ArrowLeftOutlined />
          </Button>
        }
        right={
          <Button onClick={props.onApply} size={'small'} type={'link'}>
            Apply
          </Button>
        }>
        {props.title}
      </ContentBlock>
      <Divider style={{ margin: 0 }} />
    </Space>
  );
};
